import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home'; 
import ProjectList from './components/ProjectList';
import ProjectDetail from './components/ProjectDetail';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import WhatsAppButton from './components/WhatsAppButton'; 
import ProjectDashboardGuide from "./components/ProjectDashboardGuide";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";

import ScrollToTop from './components/ScrollToTop';
import Navbar from "./components/Navbar";   // ★★★ هنا ★★★
import './App.css';
import 'leaflet/dist/leaflet.css';


function App() {
  return (
    <Router>
      <ScrollToTop /> 

      <div className="App">

        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard-guide" element={<ProjectDashboardGuide />} />
          <Route path="/projects" element={<ProjectList />} />
          <Route path="/services/:serviceTitle" element={<ProjectList />} /> 
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        <WhatsAppButton />
         <Footer />
      </div>
    </Router>
  );
}

export default App;
